import config from "appConfig";
import { LocalCourseProvider, LocalLessonProvider, LocalTaskProvider, Http } from "@jelly/lesson";

import LmsProgressProvider from "./LmsProgressProvider";
import AuthProvider from "./AuthProvider";

import courseData from "../data/course";
import lessonData from "../data/lesson";
import taskData from "../data/task";

const http = new Http({
  prefixUrl: config.API_URL,
});

export const authProvider = new AuthProvider(http);
export const courseProvider = new LocalCourseProvider(courseData);
export const taskProvider = new LocalTaskProvider(taskData);
export const lessonProvider = new LocalLessonProvider(taskProvider, lessonData);
export const progressProvider = new LmsProgressProvider(http);
